import { NewsletterArchiveTab } from "../psychologist/tabs";

export const NewsletterArchivePage = () => {
  return <NewsletterArchiveTab />;
};
